import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormControl } from '@material-ui/core';
import { TreeViewSelect, TreeViewSelectNode } from '../../../../TreeViewSelect';
import { FormFields } from '../styles';
import { AssignIdentityFormValues } from '../types';

interface SelectTeamsStepProps {
  control: Control<AssignIdentityFormValues>;
  items: TreeViewSelectNode[];
  disabled?: boolean;
}

export function SelectTeamsStep({
  control,
  items,
  disabled = false,
}: SelectTeamsStepProps) {
  return (
    <FormControl component="fieldset" style={{ width: '100%' }}>
      <FormFields>
        <Controller
          name="teamIds"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TreeViewSelect
              id="assign-identity-teams"
              items={items}
              value={field.value}
              onChange={field.onChange}
              label="Team"
              placeholder="Select teams..."
              required
              disabled={disabled}
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
        />
      </FormFields>
    </FormControl>
  );
}
